<template>
  <layout-card-wrap hasSlot>
    <template slot="title">考试成绩</template>
    <div slot="form">
      <el-button
        type="primary"
        @click="additem">
        添加成绩
      </el-button>
      <el-button
        type="info"
        @click="uploadtmp">
        导入成绩
      </el-button>
    </div>
    <el-table
      border
      :data="list">
      <el-table-column
        label="姓名"
        min-width="140"
        prop="userName">
      </el-table-column>
      <el-table-column
        label="手机号"
        width="140"
        prop="mobilePhone">
      </el-table-column>
      <el-table-column
        label="身份证"
        width="200"
        prop="idCertNo">
      </el-table-column>
      <el-table-column
        label="考试结果"
        width="165">
        <template slot-scope="{ row }">
          {{ row.evaluate === 1 ?'通过' :'未通过' }}
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        fixed="right"
        width="165">
        <template slot-scope="{ row }">
          <el-button
            type="info"
            @click="updateitem(row)">编辑</el-button>
          <el-button
            type="danger"
            @click="deleteitem(row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      slot="footer"
      background
      :current-page.sync="config.pageNum"
      :page-size="config.pageSize"
      layout="total, prev, pager, next"
      :total="total"
      @current-change="handleCurrentChange">
    </el-pagination>
    <edit-course-score-modal
      ref="course"
      :callback="() => { cb() }"
    />
    <el-upload
      ref="elUpload"
      action=""
      :limit="1"
      style="display: none;"
      accept=".xls,.xlsx"
      :show-file-list="false"
      :http-request="handleHttpRequest"
    >
      <i ref="upload"></i>
    </el-upload>
  </layout-card-wrap>
</template>
<script>
import { mapState } from 'vuex'
import EditCourseScoreModal from './edit-course-score-modal.vue'
export default {
  name: 'CourseScoreTable',
  components: { EditCourseScoreModal },
  props: {
    callback: Function,
    courseExamId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      loading: true,
      list: [],
      total: 0,
      config: {
        pageNum: 1,
        pageSize: 20,
        courseExamName: ''
      }
    }
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.account.userInfo
    })
  },
  mounted() {
    this.getlist()
  },
  methods: {
    cb() {
      this.getlist()
      this.callback && this.callback()
    },
    handleHttpRequest(file) {
      const formData = new FormData()
      formData.append('file', file.file)
      formData.append('courseExamId', this.courseExamId)
      this.loading = true
      this.$store.dispatch('account/uploadcoursescore', {
        payload: formData,
        success: () => {
          this.loading = false
          this.$message.success('上传成功')
          this.$refs.elUpload.clearFiles()
          this.getlist()
          this.callback && this.callback()
        },
        fail: () => {
          this.$refs.elUpload.clearFiles()
          this.loading = false
        }
      })
    },
    uploadtmp() {
      this.courseExamId = this.courseExamId
      this.$refs.upload.click()
    },
    updateitem(row) {
      this.$refs.course.update({
        courseExamId: row.courseExamId,
        courseScoreId: row.courseScoreId,
        userId: row.userId,
        userName: row.userName,
        mobilePhone: row.mobilePhone,
        idCertNo: row.idCertNo,
        evaluate: row.evaluate
      })
    },
    additem() {
      this.$refs.course.add({
        courseExamId: this.courseExamId
      })
    },
    deleteitem(row) {
      console.log(row)
      this.$confirm('您确定删除该考试成绩?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true
        this.$store.dispatch('account/deletecoursescore', {
          payload: {
            courseScoreId: row.courseScoreId
          },
          success: () => {
            this.loading = false
            this.getlist()
            this.callback && this.callback()
          },
          fail: () => {
            this.loading = false
          }
        })
      })
    },
    handleCurrentChange(val) {
      this.config.pageNum = val
      this.getlist()
    },
    getlist() {
      this.loading = true
      this.$store.dispatch('account/getcoursescores', {
        payload: {
          ...this.config,
          courseExamId: this.courseExamId
        },
        success: (res) => {
          this.loading = false
          this.total = res.data.total
          this.list = res.data.records
        },
        fail: () => {
          this.loading = false
        }
      })
    }
  }
}
</script>
